export enum PaymentErrors {
  ACCOUNT_BALANCE = 'balance',
  PAYPAL_FUNDS = 'ppbalance',
  PROMO_CODE = 'coupon',
  REFERENCE_TRANSACTION = 'referenceTransaction',
  CHANGE_METHOD = 'paypal-error-change-payment-method',
  DEFAULT = 'default',
}
